<template>
    <router-link
        v-if="route"
        :id="id"
        :class="{
            button: !iconOnly,
            'icon-button': iconOnly,
        }"
        :to="route"
    >
        <span
            v-if="icon"
            :class="['material-symbols-outlined', { icon: !iconOnly }]"
        >
            {{ icon }}
        </span>
        <span><slot v-if="!iconOnly"></slot></span>
    </router-link>
</template>
<script>
export default {
    name: "LinkBttn",
    props: {
        id: {
            type: String,
            default: null,
        },
        icon: {
            type: String,
            default: null,
        },
        iconOnly: {
            type: Boolean,
            default: false,
        },
        route: {
            type: String,
            default: "",
        },
    },
};
</script>
